import {Fragment, h} from 'preact';
import s from "./breadcrumbs.module.css";
import {Link} from "preact-router/match";
import {iconBreadcrumbsArrow} from "../../assets";
import {useBreadcrumbs} from "./useBreadcrumbs";
import { useAppContext } from '../../contexts';

const Breadcrumbs = props => {
    // Destructured props
    const {
        data = undefined
    } = props;
    
    // Component logic data
    const componentProps = useBreadcrumbs({
        categoryServiceType: data?.categoryServiceType,
        productName: data?.productName,
    });

    // Destructured component logic data
    const {
        formattedData,
        isReady
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Stores the listed breadcrumbs items
    const _items = formattedData.map((item, index) => {
        return (
            <div
                key={item.label}
                className={`flex-row items-center justify-start gap-x-2 ${(!isReady ? "hidden" : "flex")}`}
            >
                {index !== 0 && (
                    <img
                        src={iconBreadcrumbsArrow}
                        className={`${s.arrowIcon} ${highContrast ? "highImage" : ""}`}
                        alt={"Arrow"}
                        data-testid="breadcrumbs-img"
                    />
                )}
                {index === 0 ? (
                    <Link
                        href={"/"}
                        className={`hover:underline`}
                        data-testid="breadcrumbs-link"
                    >
                        {item.label}
                    </Link>
                ) : (
                    <p>
                        {item.label}
                    </p>
                )}
            </div>
        )
    })

    const items = (
        <p
            className={`leading-[24px] ${(!isReady ? "hidden" : "")}`}
        >
            {formattedData.map((item, index) => (
                <Fragment key={index}>
                    {index !== 0 && (
                        <img
                            src={iconBreadcrumbsArrow}
                            className={`${s.arrowIcon} ${highContrast ? "highImage" : ""}`}
                            alt={"Arrow"}
                            data-testid="breadcrumbs-img"
                        />
                    )}
                    {index === 0 ? (
                        <Link
                            href={"/"}
                            className={`hover:underline`}
                            data-testid="breadcrumbs-link"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span>
                            {item.label}
                        </span>
                    )}
                </Fragment>
            ))}
        </p>
    )

    return (
        <div className={`font-museo ${s.root} ${highContrast ? "highLabelFirst" : ""}`} data-testid="breadcrumbs-wrapper">
            {items}
        </div>
    )
}

export default Breadcrumbs;
